/**
 * Store Configuration
 */
export default {
    state: {
        version: '',
        environment: '',
    },

    mutations: {
        /**
         * Initialise le state
         */
        setVersion: function (state, version) {
            const oldVersion = localStorage.getItem('version') || ''
            localStorage.setItem('version', version)
            state.version = version
            if (oldVersion !== '' && oldVersion !== version) {
                document.location.reload(true)
            }
        },

        setEnvironment: function (state, environment) {
            state.environment = environment
        }
    },

    actions: {
        /**
         * Initialise le state
         */
        init: function (context) {
            return axios.get('/api/configuration').then(response => {
                context.commit('setEnvironment', response.data.data.environment)
                context.commit('setVersion', response.data.data.version)
                context.commit('setCreationStatuts', response.data.data.creationStatuts)
                context.commit('setStatuts', response.data.data.dossiersStatuts)
                context.commit('setTypes', response.data.data.gedTypes)
                context.commit('setSujets', response.data.data.echangeSujets)
                context.commit('setTvaStatuts', response.data.data.tvaStatuts)
                context.commit('setEquipes', response.data.data.equipes)
                context.commit('setTypeMissions', response.data.data.typeMissions)
                context.commit('setLieuxCollectes', response.data.data.lieuxCollectes)
                context.commit('setLieuxProductions', response.data.data.lieuxProductions)
                context.commit('setCabinets', response.data.data.cabinets)
                context.commit('setMailsTypes', response.data.data.mailsTypes)
                context.commit('setProvenances', response.data.data.provenances)
                context.commit('setProgrammes', response.data.data.programmes)
                context.commit('setUsers', response.data.data.users)
                context.commit('setLotClientStatus', response.data.data.lotClientStatus)
            })
        }
    },

    getters: {
        /**
         * Liste d'options
         */
        version: state => {
            return state.version
        },

        environment: state => {
            return state.environment
        },
    }
}
